import { render } from "./MainMenu.vue?vue&type=template&id=32860c9d&scoped=true&ts=true"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"

import "./MainMenu.vue?vue&type=style&index=0&id=32860c9d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/chronicle/chronicle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32860c9d"]])

export default __exports__